export default __webpack_public_path__ + "static/media/cat_overig.d8740e88.svg";